import React, { useState, useEffect, useRef } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import { HalfState } from '../../models/enums/HalfState';

const scoringControlConfigs = [
    { text: "+4", key: "+4", value: 4 },
    { text: "+3.5", key: "+3.5", value: 3.5 },
    { text: "+3", key: "+3", value: 3 },
    { text: "+2.5", key: "+2.5", value: 2.5 },
    { text: "+2", key: "+2", value: 2 },
    { text: "+1.5", key: "+1.5", value: 1.5 },
    { text: "+1", key: "+1", value: 1 },
    { text: "+0.75", key: "+0.75", value: 0.75 },
    { text: "+0.5", key: "+0.5", value: 0.5 },
    { text: "+0.3", key: "+0.3", value: 0.3 },
    { text: "+0.2", key: "+0.2", value: 0.2 },
    { text: "+0.1", key: "+0.1", value: 0.1 },
    { text: "+0.0", key: "+0.0", value: 0 },
    { text: "-0.1", key: "-0.1", value: -0.1 },
    { text: "-0.2", key: "-0.2", value: -0.2 },
    { text: "-0.3", key: "-0.3", value: -0.3 },
    { text: "-0.5", key: "-0.5", value: -0.5 },
    { text: "-0.75", key: "-0.75", value: -0.75 },
    { text: "-1", key: "-1", value: -1 },
    { text: "-1.5", key: "-1.5", value: -1.5 },
    { text: "-2", key: "-2", value: -2 },
    { text: "-2.5", key: "-2.5", value: -2.5 },
    { text: "-3", key: "-3", value: -3 },
    { text: "-3.5", key: "-3.5", value: -3.5 },
    { text: "-4", key: "-4", value: -4 },
]

function getScoringControl(isSelected, config, setActiveCb) {
    let variant = config.value >= 0 ? (isSelected ? "success" : "outline-success") : (isSelected ? "danger" : "outline-danger");

    return (<div key={config.key} style={{ padding: ".1rem .1rem" }}>
        <Button
            variant={variant}
            className="btn-block"
            size="sm"
            style={{ padding: ".1rem .1rem", fontSize: "12px" }}
            onClick={(e) => {
                if (isSelected) {
                    setActiveCb(null);
                } else {
                    setActiveCb(config);
                }
            }}
        >{config.text}</Button>
    </div>);
}

function getScoringControls(selectedScore, setActiveCb) {
    let scoringControls = [];
    for (let i = 0; i < scoringControlConfigs.length; i++) {
        const current = scoringControlConfigs[i];
        const isSelected = selectedScore && current.key == selectedScore.key;
        scoringControls.push(getScoringControl(isSelected, current, setActiveCb));
    }

    return scoringControls;
}

const ValueScoringControls = (props) => {

    const {
        selectedScore,
        setSelectedScore
    } = props;

    let scoringInputControls = getScoringControls(selectedScore, setSelectedScore);

    return <>
        <Col lg="4" style={{ paddingLeft: "5px", paddingRight: "5px" }}>
            <div style={{ height: "calc(100vh - 400px)", overflowY: "scroll" }}>
                {scoringInputControls}
            </div>
        </Col>
    </>;

}

export default ValueScoringControls;
